import Button from 'semantic-ui-react/dist/commonjs/elements/Button';
import '@purple/semantic-ui-purple-theme/components/button.css';

export default Button;
